module.exports = __webpack_public_path__ + "assets/img/ff91ea54e12b5ec5273a31fd3de7df0a.png";